// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e743200d","626":"4eee571d"}[chunkId] + ".chunk.js";
};